module.exports = __webpack_public_path__ + "static/Baden2-scaled-a82bfcabfe659a1643bdde020cfa2456.jpeg";